import {
    externalTooltipHandler,
    getXAxisScaleConfig,
    getYAxisScaleConfig,
} from '@lune-fe/lune-components-lib'
import { LuneThemeNew } from '@lune-fe/lune-ui-lib'
import moment from 'moment'
import { Range } from 'react-date-range'

import { OrderType } from 'models/order'

export interface Dataset {
    date: string
    quantity: string
    value: string
}

export interface BundleData {
    bundleId: string
    bundleName: string
    timeseries: Dataset[]
}

const { palette, typography } = LuneThemeNew

export const getDateLabels = (dataset: BundleData[]) => {
    return Array.from(
        new Set(
            dataset.reduce((acc: string[], curr) => {
                return [...acc, ...curr.timeseries.map((x: Dataset) => x.date)]
            }, []),
        ),
    )
}

// Chart options
export const chartOptions = (
    type: OrderType,
    chartData: any,
    label: string,
    currency?: string,
    dateRange?: Range,
) => {
    const rangeDuration = moment.duration(moment(dateRange?.endDate).diff(dateRange?.startDate))
    const dateUnit =
        !dateRange?.endDate || !dateRange.startDate || rangeDuration.asDays() > 364
            ? ('month' as const)
            : rangeDuration.asMonths() > 1
              ? ('week' as const)
              : ('day' as const)
    return {
        maintainAspectRatio: false,
        interaction: {
            intersect: false,
        },
        elements: {
            point: {
                radius:
                    chartData?.datasets?.length === 1 && chartData?.labels?.length === 1 ? 5 : 0,
                hoverRadius: 0,
            },
        },
        layout: {
            autoPadding: false,
        },
        scales: {
            y: getYAxisScaleConfig(label),
            x: {
                ...getXAxisScaleConfig(),
                type: 'time' as const,
                time: {
                    unit: dateUnit,
                    tooltipFormat: 'YYYY-MM-DD' as const,
                    displayFormats: {
                        month: 'MMM, YYYY',
                        week: 'DD MMM',
                        day: 'DD MMM',
                    },
                },
            },
        },
        plugins: {
            paddingBelowLegends: '30px',
            legend: {
                position: 'bottom' as const,
                align: 'start' as const,
                labels: {
                    font: {
                        family: typography.fontFamily,
                    },
                    usePointStyle: true,
                    padding: 32 as const,
                    textAlign: 'left' as const,
                    color: palette.TextPrimary,
                    boxPadding: 200,
                },
            },
            tooltip: {
                enabled: false,
                position: 'nearest' as const,
                external: (c: any) =>
                    externalTooltipHandler(c, {
                        label,
                        currency: type === OrderType.VALUE ? currency : undefined,
                    }),
            },
        },
    }
}
